import { render, staticRenderFns } from "./goldInput.vue?vue&type=template&id=7a6291ec"
import script from "./goldInput.vue?vue&type=script&lang=js"
export * from "./goldInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports